
import React, { useEffect } from "react";
import { Col, Row, Input, Button, FormGroup, Label } from "reactstrap";
import {
  FaAngleDoubleLeft,
  FaAngleLeft,
  FaChevronRight,
  FaAngleDoubleRight,
} from "react-icons/fa";

const Paginations = ({
  perPageData = 10,
  data = [],
  currentPage,
  setCurrentPage,
}) => {
   const pageCount = Math.ceil((data?.length || 0) / perPageData) || 1;

  useEffect(() => {
    if (currentPage > pageCount) {
      setCurrentPage(1);
    }
  }, [pageCount, currentPage, setCurrentPage, data]);

  const handlePrevPage = () => {
     if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < pageCount) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(pageCount);
  };

  const handlePageInputChange = (e) => {
    const value = Number(e.target.value);
     if (!isNaN(value) && value >= 1 && value <= pageCount) {
      setCurrentPage(value);
    }
  };

  useEffect(() => {
    if (currentPage > pageCount) setCurrentPage(pageCount);
  }, [pageCount, currentPage, setCurrentPage]);

  const canPreviousPage = currentPage > 1;
  const canNextPage = currentPage < pageCount;

   if (!data?.length || pageCount <= 1) {
    return null;
  }

  return (
    <div className="pagination-container">
      <Row className="justify-content-center align-items-center mb-3">
        <Col xs="12" md="auto" className="d-flex align-items-center gap-2">
          <Button
            color="secondary"
             className={canPreviousPage ? "active-page-btn" : ""}
            onClick={handleFirstPage}
            disabled={!canPreviousPage}
          >
            <FaAngleDoubleLeft />
          </Button>
          <Button
            color="secondary"
            className={canPreviousPage ? "active-page-btn" : ""}
            onClick={handlePrevPage}
            disabled={!canPreviousPage}
          >
            <FaAngleLeft />
          </Button>

          <span>
            Page <strong className="active-page-text">{currentPage}</strong> of{""}<strong>{pageCount}</strong>
          </span>

          <Input
            type="number"
            min={1}
            max={pageCount}
            style={{ width: 80, textAlign: "center" }}
            value={currentPage}
            onChange={handlePageInputChange}
            className="pagination-input"
          />

          <Button
            color="secondary"
            className={canNextPage ? "active-page-btn" : ""}
            onClick={handleNextPage}
            disabled={!canNextPage}
          >
            <FaChevronRight />
          </Button>
          <Button
            color="secondary"
            className={canNextPage ? "active-page-btn" : ""}
            onClick={handleLastPage}
            disabled={!canNextPage}
          >
            <FaAngleDoubleRight />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Paginations;
